"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.differenceAfterYear = differenceAfterYear;
exports.differenceAfterYearWithFirstYear = differenceAfterYearWithFirstYear;
exports.valueAtYearWithStandardDeviation = valueAtYearWithStandardDeviation;
exports.simpleCostDifference = simpleCostDifference;
exports.costDifference = costDifference;
exports["default"] = void 0;

// function savingsAfterYear
// Calculates the difference in accumulated value based on identical returns, but difference in costs
//
// Arguments:
// initialValue: Number
// returnPerYear: Number
// baseCostPerYear: Number
// newCostPerYear: Number
// atYear: Number
function differenceAfterYear(initialValue, returnPerYear, baseCostPerYear, newCostPerYear, atYear) {
  var baseReturns = 1 + returnPerYear - baseCostPerYear;
  var newReturns = 1 + returnPerYear - newCostPerYear;
  var differenceInReturnsAtYear = Math.pow(newReturns, atYear) - Math.pow(baseReturns, atYear);
  return initialValue * differenceInReturnsAtYear;
} // function differenceAfterYearWithFirstYear
// Calculates the difference in accumulated value based on identical returns, but difference in costs, where the first year can have a different cost
//
// Arguments:
// initialValue: Number
// returnPerYear: Number
// baseCostPerYear: Number
// costFirstYear: Number
// newCostPerYear: Number
// atYear: Number


function differenceAfterYearWithFirstYear(initialValue, returnPerYear, baseCostPerYear, newCostFirstYear, newCostPerYear, atYear) {
  var baseReturns = 1 + returnPerYear - baseCostPerYear;
  var newReturnsFirstYear = 1 + returnPerYear - newCostFirstYear;
  var newReturns = 1 + returnPerYear - newCostPerYear;
  var differenceInReturnsAtYear = newReturnsFirstYear * Math.pow(newReturns, atYear - 1) - Math.pow(baseReturns, atYear);
  return initialValue * differenceInReturnsAtYear;
} // function valueAtYearWithStandardDeviation
// Calculates the total value at a year, based on return and standard deviation.
//
// Arguments:
// initialValue: Number
// returnPerYear: Object: { average: Number, standardDeviation: Number }
// numberOfStandardDeviations: Number
// atYear: Number


function valueAtYearWithStandardDeviation(initialValue, returnPerYear, numberOfStandardDeviations, atYear) {
  var average = returnPerYear.average,
      standardDeviation = returnPerYear.standardDeviation;
  var returnAtYear = Math.pow(1 + average, atYear) + numberOfStandardDeviations * standardDeviation * Math.sqrt(atYear);
  return initialValue * returnAtYear;
} // function savingsAfterYear
// Calculates the difference in costs for a single year
//
// Arguments:
// initialValue: Number
// baseAaopFraction: Number
// baseCost: Number
// newAaopFraction: Number
// newCost: Number


function simpleCostDifference(initialValue, baseAaopFraction, baseCost, newAaopFraction, newCost) {
  return initialValue * (baseAaopFraction + baseCost - (newAaopFraction + newCost));
} // function savingsAfterYear
// Calculates the difference in costs for a single year
//
// Arguments:
// initialValue: Number
// baseAaopFraction: Number
// baseCost: Number
// newAaopFraction: Number
// newCost: Number
// ---------------
// Returns:
// totalBaseCostFraction: Number
// totalBaseCost: Number
// totalNewCostFraction: Number
// totalNewCost: Number
// totalSaved: Number
// totalSavedFraction: Number


function costDifference(initialValue, baseAaopFraction, baseCost, newAaopFraction, newCost) {
  var totalBaseCostFraction = baseAaopFraction + baseCost;
  var totalBaseCost = initialValue * totalBaseCostFraction;
  var totalNewCostFraction = newAaopFraction + newCost;
  var totalNewCost = initialValue * totalNewCostFraction;
  var totalSaved = totalBaseCost - totalNewCost;
  var totalSavedFraction = totalBaseCostFraction - totalNewCostFraction;
  return {
    totalBaseCostFraction: totalBaseCostFraction,
    totalBaseCost: totalBaseCost,
    totalNewCostFraction: totalNewCostFraction,
    totalNewCost: totalNewCost,
    totalSaved: totalSaved,
    totalSavedFraction: totalSavedFraction
  };
}

var _default = {
  differenceAfterYear: differenceAfterYear,
  differenceAfterYearWithFirstYear: differenceAfterYearWithFirstYear,
  valueAtYearWithStandardDeviation: valueAtYearWithStandardDeviation,
  simpleCostDifference: simpleCostDifference,
  costDifference: costDifference
};
exports["default"] = _default;